module.exports = __webpack_public_path__ + "img/FR13878.215de9a1.png";